import { CircularProgress } from "@material-ui/core";
import axios from "axios";
import React from "react";
import { useEffect, useState } from "react";
import CreatorInfo from "./CreatorInfo";
import PizzaViewer from "./Pizza-Viewer";

//Wrapper around pizza viewer but we handle getting the model as well
export default function AutoPizzaViewer(props: { modelid: string; className?: string | undefined; }) {
    const [model, setmodel] = useState(null);
    useEffect(() => {
        //get model details from server
        axios.get(`/api/model/${props.modelid}/details`).then(res => {
            setmodel(res.data);
        });
    }, [props.modelid]);

    if (model === null)
        return <div className="aspect-video flex items-center justify-center"><CircularProgress/></div>;

    return (
        <div className={"relative aspect-video !mb-6 " + props.className}>
            <CreatorInfo Creator={model.Creator} className={'absolute top-2 left-2 z-10'} whiteIcons hideSocials/>
            <PizzaViewer model={model} className={'w-full h-full'} paperClassName={'!rounded-md'} OpenButton />
        </div>
    )
}